// ================================
// Utility: Wait for element to exist (No Timeout)
// ================================
function waitForElement(selector, callback, interval = 400) {
    const timer = setInterval(() => {
        const el = document.querySelector(selector);
        if (el) {
            clearInterval(timer);
            callback(el);
        }
    }, interval);
}

// ================================
// Autocomplete Initialization
// ================================
function initAutocomplete() {
    const inputField = document.getElementById('address-input');
    const resultsContainer = document.getElementById('autocomplete-results');

    if (!inputField || !resultsContainer) {
        console.error('Required DOM elements not found. Ensure the IDs "address-input" and "autocomplete-results" exist.');
        return;
    }

    const autocompleteService = new google.maps.places.AutocompleteService();
    let debounceTimeout;
    const debounceDelay = 300;
    const minCharacters = 5;

    // --- RESTRICTION CONFIGURATION ---
    const restrictedPatterns = /\b(p\.?\s*o\.?|post\s*office|g\.?p\.?o\.?|private|locked)\s*(box|bag)\b|parcel\s*(locker|collect)/i;

    inputField.addEventListener('input', function () {
        const input = inputField.value.trim();
        clearTimeout(debounceTimeout);

        if (input.length < minCharacters) {
            resultsContainer.innerHTML = '';
            resultsContainer.style.display = 'none';
            return;
        }

        // --- 1. IMMEDIATE INPUT CHECK (PO BOX / PARCEL LOCKER) ---
        if (restrictedPatterns.test(input)) {
            console.warn('Restricted address type detected:', input);
            resultsContainer.innerHTML = `
                <div class="autocomplete-result" style="color: #dc3545; cursor: default; background: #fff0f1; border-left: 4px solid #dc3545; padding: 12px;">
                    <strong>Delivery restricted:</strong><br>
                    Sorry, we cannot deliver to PO Boxes or Parcel Lockers. <br>
                    Please enter a physical street address.
                </div>
            `;
            resultsContainer.style.display = 'block';
            return; // Stop here. Do not call Google API.
        }

        debounceTimeout = setTimeout(() => {
            console.log(`Requesting predictions for: "${input}"`); 
            autocompleteService.getPlacePredictions(
                { input, componentRestrictions: { country: 'au' } },
                displayResults
            );
        }, debounceDelay);
    });
}

// ================================
// Display Autocomplete Results
// ================================
function displayResults(predictions, status) {
    const inputField = document.getElementById('address-input');
    const resultsContainer = document.getElementById('autocomplete-results');
    if (!inputField || !resultsContainer) return;

    if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions) {
        console.warn(`Autocomplete failed or returned no results. Status: ${status}`);
        resultsContainer.innerHTML = '';
        resultsContainer.style.display = 'none';
        return;
    }

    resultsContainer.innerHTML = '';
    resultsContainer.style.display = 'block';

    predictions.forEach(prediction => {
        const item = document.createElement('div');
        item.classList.add('autocomplete-result');
        item.textContent = prediction.description;

        item.addEventListener('click', () => {
            inputField.value = prediction.description;
            resultsContainer.innerHTML = '';
            resultsContainer.style.display = 'none';

            const placesService = new google.maps.places.PlacesService(inputField);
            placesService.getDetails({ placeId: prediction.place_id }, (place, status) => {
                if (status === google.maps.places.PlacesServiceStatus.OK) {
                    displayAddressDetails(place, prediction.description);
                }
            });
        });

        resultsContainer.appendChild(item);
    });
}

// ================================
// Display Address Components
// ================================
function displayAddressDetails(place, originalDescription = '') {
    const streetField = document.getElementById('street');
    const suburbField = document.getElementById('suburb');
    const stateField = document.getElementById('state');
    const postcodeField = document.getElementById('postcode');
    // We need the results container again to show state errors
    const resultsContainer = document.getElementById('autocomplete-results'); 

    if (!streetField || !suburbField || !stateField || !postcodeField) return;

    let unitnumber = '', streetnumber = '', street = '', suburb = '', state = '', postcode = '';

    place.address_components.forEach(component => {
        const types = component.types;
        if (types.includes('subpremise')) unitnumber = component.long_name;
        if (types.includes('street_number')) streetnumber = component.long_name;
        if (types.includes('route')) street = component.long_name;
        if (types.includes('locality')) suburb = component.long_name;
        if (types.includes('administrative_area_level_1')) state = component.short_name;
        if (types.includes('postal_code')) postcode = component.long_name;
    });

    // --- 2. STATE RESTRICTION CHECK (TAS / NT) ---
    const restrictedStates = ['TAS', 'NT', 'TASMANIA', 'NORTHERN TERRITORY'];
    
    if (state && restrictedStates.includes(state.toUpperCase())) {
        console.warn(`Restricted state detected: ${state}`);
        
        // Clear internal fields
        streetField.textContent = '';
        suburbField.textContent = '';
        stateField.textContent = '';
        postcodeField.textContent = '';
        
        // Clear visible input
        const inputField = document.getElementById('address-input');
        if (inputField) inputField.value = '';
        
        // Show error message
        if (resultsContainer) {
            resultsContainer.innerHTML = `
                <div class="autocomplete-result" style="color: #dc3545; cursor: default; background: #fff0f1; border-left: 4px solid #dc3545; padding: 12px;">
                     Sorry, we do not deliver to <strong>${state}</strong> at this time.
                </div>
            `;
            resultsContainer.style.display = 'block';
        }
        return; // STOP HERE. Do not call postAddressDetails.
    }

    // Restore unit / number from original description if missing
    if (originalDescription) {
        const match = originalDescription.match(/^(unit\s+)?([\w-]+\/)?(\d+[A-Za-z]?(-\d+)?)/i);
        if (match) {
            let unitWord = match[1] ? match[1].trim() : '';
            let fullPrefix = match[2] ? match[2].replace('/', '') : '';
            let fullNumber = match[3] || '';

            fullPrefix = fullPrefix.replace(/[a-z]/g, m => m.toUpperCase());
            fullNumber = fullNumber.replace(/[a-z]/g, m => m.toUpperCase());

            if (fullPrefix && !unitnumber) unitnumber = fullPrefix;
            if (fullNumber && fullNumber !== streetnumber) streetnumber = fullNumber;

            if (unitWord) {
                unitWord = unitWord.charAt(0).toUpperCase() + unitWord.slice(1).toLowerCase();
                if (!unitnumber.toLowerCase().startsWith('unit')) unitnumber = unitWord + ' ' + unitnumber;
                else unitnumber = unitnumber.replace(/^unit/i, 'Unit');
            }
        }
    }

    const fullStreet = `${unitnumber ? unitnumber + '/' : ''}${streetnumber} ${street}`.trim();
    console.log('RESULT fullStreet:', fullStreet);

    streetField.textContent = fullStreet;
    suburbField.textContent = suburb;
    stateField.textContent = state;
    postcodeField.textContent = postcode;

    // Proceed to API call only if validation passed
    postAddressDetails(suburb, postcode);
}

// ================================
// POST Address to API
// ================================
async function postAddressDetails(suburb, postcode) {
    const street = document.getElementById('street').textContent.trim();
    const suburbValue = document.getElementById('suburb').textContent.trim();
    const state = document.getElementById('state').textContent.trim();
    const postcodeValue = document.getElementById('postcode').textContent.trim();

    // Ensure token is ready
    const tokenEl = document.getElementById('cart-unique');
    let token = tokenEl ? tokenEl.textContent.trim() : '';
    if (!token) {
        token = await fetchCartTokenWithRetry();
        if (tokenEl) tokenEl.textContent = token;
    }

    const buttonContainer = document.getElementById('button-container');
    const loadingIndicator = document.getElementById('loading-indicator');
    const url = 'https://shipping.pistachiopapi.com.au/check-service';

    const data = {
        street,
        suburb: suburbValue,
        state,
        postcode: postcodeValue,
        token,
        date: new Date().toISOString().slice(0, 19).replace('T', ' '),
        delivery: 'placeholder'
    };

    if (loadingIndicator) loadingIndicator.style.display = 'flex';

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
        });
        const json = await response.json();

        if (loadingIndicator) loadingIndicator.style.display = 'none';
        if (buttonContainer) buttonContainer.innerHTML = json.html || '';

        initButtonToggle();

        if (json.html && !json.html.includes('Sorry, delivery is not available')) {
            const modal = document.getElementById('address-modal');
            if (modal) modal.style.display = 'flex';
        }
    } catch (err) {
        if (loadingIndicator) loadingIndicator.style.display = 'none';
        console.error('Error posting address:', err);
    }
}

function initButtonToggle() {
    waitForElement('#button-container', (buttonContainer) => {
        const confirmBtn = document.getElementById('confirm');
        const changeAddressBtn = document.getElementById('change-address'); 
        const modal = document.getElementById('address-modal');
        const cartFooter = document.getElementById('cart-footer'); 
        const addressInput = document.getElementById('address-input');

        // 1. Handle CONFIRM Click (API + UI Transition)
        if (confirmBtn) {
            const newConfirmBtn = confirmBtn.cloneNode(true);
            confirmBtn.parentNode.replaceChild(newConfirmBtn, confirmBtn);

            newConfirmBtn.addEventListener('click', async () => {
                const deliveryEl = document.getElementById('delivery-data');
                if (!deliveryEl) return;

                const payload = {
                    note: `Selected Date: ${deliveryEl.getAttribute('data-date')}, Timeslot: ${deliveryEl.getAttribute('data-timeslot')}`,
                    addressData: {
                        street: document.getElementById('street')?.textContent.trim(),
                        suburb: document.getElementById('suburb')?.textContent.trim(),
                        state: document.getElementById('state')?.textContent.trim(),
                        postcode: document.getElementById('postcode')?.textContent.trim()
                    },
                    token: document.getElementById('cart-unique')?.textContent.trim(),
                    datetime: new Date().toISOString(),
                    address_update: false
                };

                try {
                    newConfirmBtn.disabled = true;
                    const resp = await fetch('https://shipping.pistachiopapi.com.au/cart', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(payload)
                    });

                    if (resp.ok) {
                        console.log('API Success. Transitioning UI...');
                        
                        if (modal) {
                            modal.style.display = 'none';
                            console.log('Hid address modal');
                        }
                        if (cartFooter) {
                            cartFooter.style.display = 'block';
                            console.log('Displayed cart footer');
                        }
                    }
                } catch (err) {
                    console.error('Confirmation failed:', err);
                } finally {
                    newConfirmBtn.disabled = false;
                }
            });
        }

        // 2. Handle CHANGE ADDRESS Click
        if (changeAddressBtn) {
            changeAddressBtn.addEventListener('click', () => {
                console.log('Change address button clicked');
                if (modal) {
                    const deliveryData = document.getElementById('delivery-data');
                    if (deliveryData) deliveryData.style.display = 'none';
                    modal.style.display = 'none';
                }
                if (addressInput) {
                    addressInput.value = '';
                    addressInput.focus();
                }
            });
        }
    });
}

// ================================
// Cart Token Handling
// ================================
async function fetchCartTokenWithRetry(retries = 5, delay = 500) {
    for (let i = 0; i < retries; i++) {
        try {
            const response = await fetch('/cart.js');
            if (!response.ok) throw new Error(`Error fetching cart: ${response.statusText}`);

            const data = await response.json();
            if (data?.token) return data.token;

            console.warn(`Token not found. Retry ${i + 1}/${retries}`);
        } catch (err) {
            console.error('Error fetching cart token:', err);
        }
        await new Promise(res => setTimeout(res, delay));
    }
    throw new Error('Failed to fetch valid cart token after retries.');
}

async function handleCartUpdates() {
    try {
        const token = await fetchCartTokenWithRetry();
        const tokenEl = document.getElementById('cart-unique');
        if (tokenEl) tokenEl.textContent = token;
        console.log('Cart token updated:', token);
    } catch (err) {
        console.error('Error updating cart token:', err);
    }
}

function attachCartUpdateListener() {
    document.addEventListener('cart:updated', handleCartUpdates);

    let lastToken = null;
    setInterval(async () => {
        const el = document.getElementById('cart-unique');
        const currentToken = el ? el.textContent.trim() : '';
        if (!currentToken || currentToken !== lastToken) {
            lastToken = await fetchCartTokenWithRetry();
            if (el) el.textContent = lastToken;
        }
    }, 1000);
}

// ================================
// Initialize All
// ================================
document.addEventListener('DOMContentLoaded', () => {
    // *** THIS IS THE FIX ***
    // First, wait for your input field
    waitForElement('#address-input', (inputElement) => {
        
        // OK, the input exists. Now, wait for the Google API to be loaded.
        const apiCheckInterval = setInterval(() => {
            try {
                // Check if the 'google.maps.places' object is available
                if (window.google && window.google.maps && window.google.maps.places) {
                    
                    // It's ready! Clear the timer and run your function.
                    clearInterval(apiCheckInterval);
                    console.log('Google Maps API and #address-input are ready. Initializing.');
                    initAutocomplete(); // Now it's safe to run
                }
            } catch (e) {
                console.error('Error checking for Google API.', e);
                clearInterval(apiCheckInterval);
            }
        }, 100); // Check every 100ms

        // Add a safety timeout in case the API script never loads
        setTimeout(() => {
            clearInterval(apiCheckInterval);
            if (!window.google || !window.google.maps || !window.google.maps.places) {
                console.error('Google Maps API failed to load after 10 seconds. Check script tag.');
            }
        }, 10000); // 10-second timeout
    });
    // *** END OF FIX ***

    // These can still be initialized as before
    waitForElement('#button-container', initButtonToggle);
    attachCartUpdateListener();
    handleCartUpdates();
});